export const CONTEXT_KIND_ATTRIBUTE = 'kind';
export const CONTEXT = 'context';

export const RESERVED_CONTEXT_KIND_KEYS = ['multi', 'kind'];
